/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Domains, EventTypes, UserTokenError, WindowMessageData } from '@app/types';

const _buildInvalidTokenEventMessage = ({
  eventType,
  message,
  details,
  subject,
}: UserTokenError): WindowMessageData => {
  const invalidTokenEventMessage: WindowMessageData = {
    domain: Domains.Usage,
    eventType,
    subject,
    data: {
      message,
      details,
    },
  };

  return invalidTokenEventMessage;
};

const sendDataToParent = (data?: unknown) => {
  // TODO pull targetOrigin domain from env
  const targetOrigin = '*';
  const sentData = typeof data === 'string' ? JSON.parse(data) : data;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (window.ReactNativeWebView & !isPWAMyViasat()) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.ReactNativeWebView.postMessage(JSON.stringify(sentData));
  } else {
    // Note: stringifying and unstringifying intentionally here
    // This makes sure Mozilla's postMessage doesn't error trying to serialize the object

    window.parent?.postMessage(sentData, targetOrigin);
  }
};

const _dispatchUserTokenError = (userTokenError: UserTokenError): void => {
  const invalidTokenEventMessage = _buildInvalidTokenEventMessage(userTokenError);

  sendDataToParent(JSON.stringify(invalidTokenEventMessage));
};

const _isClient = () => {
  return typeof window != 'undefined' && window.document;
};

const _noTokenProvidedError = (noTokenProvided: boolean): UserTokenError => {
  const userTokenError = {
    eventType: EventTypes.NoTokenProvided,
    message: `A user token was not found, domain ${Domains.Usage} is not logged in.`,
    details: { noTokenProvided },
  };

  return userTokenError;
};

const _invalidTokenError = (error: Error): UserTokenError => {
  const userTokenError = {
    eventType: EventTypes.InvalidToken,
    message: error.message,
    details: { error },
  };

  return userTokenError;
};

export const handleUserTokenErrors = (
  noTokenProvided: boolean,
  invalidTokenError: Error | undefined,
  subject?: string
): UserTokenError | undefined => {
  let userTokenError: UserTokenError | undefined;
  if (_isClient() && noTokenProvided) {
    userTokenError = _noTokenProvidedError(noTokenProvided);
  } else if (invalidTokenError) {
    userTokenError = _invalidTokenError(invalidTokenError);
  }

  if (userTokenError) {
    _dispatchUserTokenError({ ...userTokenError, subject });
  }

  return userTokenError;
};
